<ng-container *ngxPermissionsOnly="menu?.permission">
  <div class="move-left"
       style="--order: {{ index * 0.7 }}">
    <ng-container *ngIf="!menu.children">
      <div [routerLink]="menu?.route"
           class=" p-2 rounded-md  {{showToggle ? 'bg-grey/40 text-gray-500 text-xs':'bg-primary text-white text-sm hover:bg-primary-300 px-4'}}
                    transform cursor-pointer  transition-all duration-300"
           matRipple [routerLinkActive]="showToggle? 'active-menu':'active-menu-2'">
        <div class="flex justify-start items-center gap-2 active-menu-item">
          <ng-container *ngIf="menu.icon">
            <mat-icon *ngIf="menu.iconType == 'SVG'" [svgIcon]="menu.icon"
                      class="!h-6 !w-6 scale-75  opacity-80 transition-all duration-300 group-hover:opacity-100"></mat-icon>
            <mat-icon *ngIf="menu.iconType == 'MAT'"
                      class="opacity-80 scale-75 transition-all duration-300 group-hover:!opacity-100">{{
                menu.icon
              }}
            </mat-icon>
          </ng-container>
          <div>{{ menu?.name |titlecase }}</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="menu?.children">
      <button
        (mouseover)="mouseEnter(menuX)"
        [matMenuTriggerFor]="menuX"
        [ngClass]="isActiveRoute(menu?.children) ? showToggle? 'active-menu':'active-menu-2':''"
        class="transition  p-2  rounded-md
                    transform cursor-pointer {{showToggle ? 'bg-grey/40 text-gray-500 text-xs':'bg-primary text-white text-sm hover:bg-primary-300 px-4'}}">
        <div class="flex justify-start items-center gap-1">
          <ng-container *ngIf="menu.icon">
            <mat-icon *ngIf="menu.iconType == 'SVG'" [svgIcon]="menu.icon"
                      class="!h-6 !w-6 scale-75 opacity-80 transition-all duration-300 group-hover:opacity-100"></mat-icon>
            <mat-icon *ngIf="menu.iconType == 'MAT'"
                      class=" opacity-80 scale-75 transition-all duration-300 group-hover:!opacity-100">{{ menu.icon }}
            </mat-icon>
          </ng-container>
          <div>{{ menu?.name |titlecase}}</div>
          <mat-icon class="{{showToggle ?'text-gray-500/50':'text-neutral-light'}}">expand_more</mat-icon>
        </div>
      </button>
      <mat-menu #menuX="matMenu" (mouseout)="mouseLeave(menuX)" class="mat-elevation-z0">
        <div class="flex flex-col pr-2">
          <div *ngFor="let menuItem of menu?.children; let k = index" class="flex flex-col group">
            <ng-container *ngxPermissionsOnly="menuItem?.permission">
              <ng-container *ngIf="!menuItem.children">
                <div class="flex ml-4 border-l border-l-primary-800/40 items-center h-full">
                  <div class="w-6">
                    <mat-divider class="bg-primary-800/40"></mat-divider>
                  </div>
                  <div
                    [routerLink]="menuItem.route"
                    class="!pr-8 !pl-4 !py-4 w-full text-xs rounded-lg cursor-pointer flex items-center group-hover:!bg-gray-100 transition transform "
                    matRipple
                    routerLinkActive="active-menu-sub">
                    <div
                      class="h-[4px] w-[4px] transition-all duration-300 group-hover:w-[12px] rounded-full bg-gray-300 mr-3">
                    </div>
                    <span>{{ menuItem.name |titlecase}}</span>
                  </div>
                </div>
              </ng-container>

              <!--                    <ng-container *ngIf="menuItem?.children">-->
              <!--                      <mat-accordion>-->
              <!--                        <mat-expansion-panel-->
              <!--                          (click)="currentMenu = menuItem?.key"-->
              <!--                          [expanded]=" !!menuItem?.key && menuItem?.key == currentMenu">-->
              <!--                          <mat-expansion-panel-header-->
              <!--                            class="hover:!bg-menu-hover transition transform hover:scale-x-102 border-r-4 border-r-transparent hover:border-r-primary">-->
              <!--                            <mat-panel-title class="big-menu-items !pl-4"> <span *ngIf="menuItem.icon"-->
              <!--                                                                                 class="ks-icon fa fa-{{ menuItem?.icon }}"></span>-->
              <!--                              <span-->
              <!--                                *ngIf="menuItem?.icon">&nbsp;</span> {{ menuItem?.name }}-->
              <!--                            </mat-panel-title>-->
              <!--                          </mat-expansion-panel-header>-->
              <!--                          <div class="flex flex-col">-->
              <!--                            &lt;!&ndash;                                  <mat-divider></mat-divider>&ndash;&gt;-->
              <!--                            <ng-container *ngFor="let menuItemChild of menuItem?.children; let i = index">-->
              <!--                              <div *ngxPermissionsOnly="menuItemChild?.permission" class="flex flex-col">-->
              <!--                                <div>-->
              <!--                                  <a [routerLink]="menuItemChild.route"-->
              <!--                                     class="!pl-12 !py-5 font-light hover:!bg-menu-hover transition transform hover:scale-x-102"-->
              <!--                                     routerLinkActive="active-menu"> <span-->
              <!--                                    *ngIf="menuItemChild?.icon">&nbsp;</span>-->
              <!--                                    <span>{{-->
              <!--                                        menuItemChild.name-->
              <!--                                      }}</span> </a>-->
              <!--                                  &lt;!&ndash;                                      <mat-divider&ndash;&gt;-->
              <!--                                  &lt;!&ndash;                                        *ngIf="menuItem.children?.length != i + 1"></mat-divider>&ndash;&gt;-->
              <!--                                </div>-->
              <!--                              </div>-->
              <!--                            </ng-container>-->
              <!--                          </div>-->
              <!--                        </mat-expansion-panel>-->
              <!--                      </mat-accordion>-->
              <!--                    </ng-container>-->
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </ng-container>
  </div>
</ng-container>
